export const alertAutoCloseConfig = {
  timeout: 5000,
  autoCloseInfo: true,
  autoCloseSuccess: true,
  autoCloseWarning: true,
  autoCloseError: true
};